import {
  PrivateRoute,
  callbackRoute,
  useSession,
} from '@airship-platform/airship-auth';
import {
  roleHomePaths,
  withPageProps,
} from '@airship-platform/airship-patterns';
import {
  NotAuthorized as BaseNotAuthorized,
  NotFoundPage as BaseNotFoundPage,
  Loader,
} from '@airship-platform/jam-web/components';
import { useEffect } from 'react';
import { RouteObject } from 'react-router';

const userTypePathsMap = {
  ...roleHomePaths,
  UNKNOWN: '/404',
};

const HomePage: React.FC = withPageProps(
  () => {
    const { claims } = useSession();

    useEffect(() => {
      const role = claims?.userRole || 'UNKNOWN';
      window.location.replace(userTypePathsMap[role] || '/403');
    }, [claims?.userRole]);

    return null;
  },
  { title: 'Platform Home' }
);

const routes: RouteObject[] = [
  callbackRoute(),
  {
    path: '*',
    Component: withPageProps(BaseNotFoundPage, { title: 'Page not found' }),
  },
  {
    path: '403',
    Component: withPageProps(BaseNotAuthorized, { title: 'Not Authorized' }),
  },
  {
    path: '/',
    element: (
      <PrivateRoute loadingComponent={<Loader isLoading />}>
        <HomePage />
      </PrivateRoute>
    ),
  },
];

export default routes;
